import * as React from "react";
import { Linking } from "react-native";

import { makeExternalLinks } from "~/utils/external-links";
import { LinkBox, LinkText, Links } from "../../styles";
import { messages } from "../../intl";

export const BottomLinks = () => {
  const handleOpenLink = React.useCallback((url: string) => {
    Linking.openURL(url);
  }, []);

  return (
    <Links>
      <LinkBox
        onPress={() => handleOpenLink(makeExternalLinks().PRIVACY_POLICY)}
      >
        <LinkText>{messages.privacyPolicy}</LinkText>
      </LinkBox>
      <LinkBox
        onPress={() => handleOpenLink(makeExternalLinks().TERMS_AND_CONDITIONS)}
        isRight
      >
        <LinkText>{messages.terms}</LinkText>
      </LinkBox>
    </Links>
  );
};
